import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, OnDestroy, ViewChild, forwardRef, inject } from '@angular/core';
import { DemoDialog, DemoUiService } from '../core/demo-ui.service';

@Component({
  selector: 'rv-demo-dialog', standalone: true, changeDetection: ChangeDetectionStrategy.OnPush,
  template: `@if (ui.dialog(); as config) { <rv-dialog-content [config]="config"/> }
    <div id="toast" role="status" aria-live="polite" [class.visible]="!!ui.message()">{{ ui.message() }}</div>`,
  imports: [forwardRef(() => DialogContentComponent)]
})
export class DemoDialogComponent { readonly ui = inject(DemoUiService); }

import { input } from '@angular/core';
@Component({ selector: 'rv-dialog-content', standalone: true, changeDetection: ChangeDetectionStrategy.OnPush,
  template: `<dialog #modal aria-labelledby="demo-dialog-title" (cancel)="ui.close()" (close)="ui.close()">
    <button class="close" aria-label="Cerrar" (click)="ui.close()">×</button>
    <div class="eyebrow">REINVENT-VIGILANCIA / DEMO</div><h2 id="demo-dialog-title">{{config().title}}</h2>
    <p>{{config().description}}</p><form (submit)="submit($event)">
    @for (field of config().fields ?? []; track field.name) { <label [for]="'demo-' + field.name">{{field.label}}</label>
      <input [id]="'demo-' + field.name" [name]="field.name" [type]="field.type || 'text'" required maxlength="120" [attr.minlength]="field.type === 'password' ? 6 : null" autocomplete="off"> }
    @if (config().fields?.length) { <button class="button" type="submit">Confirmar demostración ↗</button> }</form>
    <p class="form-note">Datos de ejemplo. No se envían datos ni se conceden permisos reales.</p></dialog>` })
export class DialogContentComponent implements AfterViewInit, OnDestroy {
  readonly config = input.required<DemoDialog>(); readonly ui = inject(DemoUiService);
  @ViewChild('modal', { static: true }) modal!: ElementRef<HTMLDialogElement>;
  private previousFocus = document.activeElement;
  ngAfterViewInit(): void { this.modal.nativeElement.showModal(); }
  ngOnDestroy(): void { this.modal.nativeElement.close(); if (this.previousFocus instanceof HTMLElement) this.previousFocus.focus(); }
  submit(event: Event): void {
    event.preventDefault(); const values = Object.fromEntries(new FormData(event.target as HTMLFormElement).entries()) as Record<string, string>;
    const callback = this.config().submit; this.ui.close(); callback?.(values);
  }
}
